import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LanguageAbbreviation } from '@/constants/common';
import translation_de from './de';
import translation_en from './en';
import translation_es from './es';
import translation_fr from './fr';
import translation_id from './id';
import translation_ja from './ja';
import { withKnowledgeGraphTranslation } from './knowledge-graph';
import translation_pt_br from './pt-br';
import translation_ru from './ru';
import { createTranslationTable, flattenObject } from './until';
import translation_vi from './vi';
import translation_zh from './zh';
import translation_zh_traditional from './zh-traditional';

const resources = {
  [LanguageAbbreviation.En]: withKnowledgeGraphTranslation(
    translation_en,
    'en',
  ),
  [LanguageAbbreviation.Zh]: withKnowledgeGraphTranslation(
    translation_zh,
    'zh',
  ),
  [LanguageAbbreviation.ZhTraditional]: withKnowledgeGraphTranslation(
    translation_zh_traditional,
    'zh-TRADITIONAL',
  ),
  [LanguageAbbreviation.Id]: withKnowledgeGraphTranslation(
    translation_id,
    'id',
  ),
  [LanguageAbbreviation.Ja]: withKnowledgeGraphTranslation(
    translation_ja,
    'ja',
  ),
  [LanguageAbbreviation.Es]: withKnowledgeGraphTranslation(
    translation_es,
    'es',
  ),
  [LanguageAbbreviation.Vi]: withKnowledgeGraphTranslation(
    translation_vi,
    'vi',
  ),
  ru: withKnowledgeGraphTranslation(translation_ru, 'ru'),
  [LanguageAbbreviation.PtBr]: withKnowledgeGraphTranslation(
    translation_pt_br,
    'pt-BR',
  ),
  [LanguageAbbreviation.De]: withKnowledgeGraphTranslation(
    translation_de,
    'de',
  ),
  [LanguageAbbreviation.Fr]: withKnowledgeGraphTranslation(
    translation_fr,
    'fr',
  ),
};
const flattenResource = (resource: unknown) =>
  flattenObject(resource as Parameters<typeof flattenObject>[0]);
const enFlattened = flattenResource(resources.en);
const viFlattened = flattenResource(resources.vi);
const ruFlattened = flattenResource(resources.ru);
const esFlattened = flattenResource(resources.es);
const zhFlattened = flattenResource(resources.zh);
const jaFlattened = flattenResource(resources.ja);
const pt_brFlattened = flattenResource(resources['pt-BR']);
const zh_traditionalFlattened = flattenResource(resources['zh-TRADITIONAL']);
const deFlattened = flattenResource(resources.de);
const frFlattened = flattenResource(resources.fr);
export const translationTable = createTranslationTable(
  [
    enFlattened,
    viFlattened,
    ruFlattened,
    esFlattened,
    zhFlattened,
    zh_traditionalFlattened,
    jaFlattened,
    pt_brFlattened,
    deFlattened,
    frFlattened,
  ],
  [
    'English',
    'Vietnamese',
    'Rus',
    'Spanish',
    'zh',
    'zh-TRADITIONAL',
    'ja',
    'pt-BR',
    'Deutsch',
    'French',
  ],
);
i18n.use(initReactI18next).init({
  supportedLngs: [LanguageAbbreviation.Zh],
  resources,
  fallbackLng: 'zh',
  lng: 'zh',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
